/**
 * @voltxampere/ui — LM4040-5.0 voltage reference variant (Sprint 42-3)
 *
 * Reference: TI LM4040-5.0. Fixed 5.000 V shunt voltage reference,
 * ±0.1 %, SOT-23.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const referenceLm4040_5v = {
    id: "lm4040-5v",
    nameTr: "LM4040-5.0 (Hassas Referans 5.0V, SOT-23)",
    nameEn: "LM4040-5.0 (Precision Reference 5.0V, SOT-23)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "LM4040-5.0",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=reference-lm4040-5v.js.map